import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=2e9fd5b2&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=ts&"
export * from "./SideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=2e9fd5b2&lang=scss&scoped=true&"
import style1 from "./SideMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9fd5b2",
  null
  
)

export default component.exports